import React from 'react';
import { ArrowTopRight } from 'assets/icons';
import CustomLink, { CustomLinkProps } from 'components/shared/CustomLink';
import styles from './StyleConstants.module.css';

export const MainStyled = ({
  className,
  ...props
}: React.HTMLAttributes<HTMLElement>) => (
  <main
    className={`${styles.main}${className ? ` ${className}` : ''}`}
    {...props}
  />
);

export const I_playfair = ({
  className,
  ...props
}: React.HTMLAttributes<HTMLElement>) => (
  <i
    className={`${styles.iPlayfair}${className ? ` ${className}` : ''}`}
    {...props}
  />
);

export const H2Caption = ({
  className,
  ...props
}: React.HTMLAttributes<HTMLHeadingElement>) => (
  <h2
    className={`${styles.h2Caption}${className ? ` ${className}` : ''}`}
    {...props}
  />
);

export const H2LG = ({
  className,
  ...props
}: React.HTMLAttributes<HTMLHeadingElement>) => (
  <h2
    className={`${styles.h2LG}${className ? ` ${className}` : ''}`}
    {...props}
  />
);

export const Button = ({
  className,
  children,
  arrowIcon: _arrowIcon,
  ...props
}: React.ButtonHTMLAttributes<HTMLButtonElement> & {
  arrowIcon?: boolean;
}) => (
  <button
    className={`${styles.underlineBtn}${className ? ` ${className}` : ''}`}
    {...props}
  >
    {children} <ArrowTopRight />
  </button>
);

export const LinkUl = ({
  className,
  children,
  arrowIcon: _arrowIcon,
  ...props
}: React.AnchorHTMLAttributes<HTMLAnchorElement> & {
  arrowIcon?: boolean;
}) => (
  <a
    className={`${styles.underlineBtn}${className ? ` ${className}` : ''}`}
    {...props}
  >
    {children} <ArrowTopRight />
  </a>
);

export const LinkButton = React.forwardRef<HTMLAnchorElement, CustomLinkProps>(
  function LinkButton({ className, ...props }, ref) {
    return (
      <CustomLink
        ref={ref}
        className={`${styles.linkButton}${className ? ` ${className}` : ''}`}
        {...props}
      />
    );
  },
);
